import { render } from "./TwoDCharacter.vue?vue&type=template&id=3a15fd84&scoped=true"
import script from "./TwoDCharacter.vue?vue&type=script&lang=js"
export * from "./TwoDCharacter.vue?vue&type=script&lang=js"

import "./TwoDCharacter.vue?vue&type=style&index=0&id=3a15fd84&scoped=true&lang=css"

import exportComponent from "/Users/macpc-2/Downloads/Sitepal-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a15fd84"]])

export default __exports__